export default "__VITE_ASSET__i5Veo8UB__"